var map = {
	"./STERiJECT_01.png": "d805",
	"./STERiJECT_02.png": "fcb0",
	"./STERiJECT_04.png": "0041",
	"./STERiJECT_05.png": "028d",
	"./STERiJECT_s2.png": "d339"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b6bb";